export interface AuthSession {
  accessToken: string;
  refreshToken: string;
}

const storageKey = 'archive-search.auth';

export function readAuthSession(): AuthSession | null {
  try {
    const value = window.localStorage.getItem(storageKey);
    if (!value) return null;
    const session = JSON.parse(value) as Partial<AuthSession>;
    if (!session.accessToken || !session.refreshToken) return null;

    // A session stored by the old cookie mode carries placeholder tokens that
    // would be sent as a bearer header and rejected on every request. Dropping
    // it turns that into one ordinary login.
    if (session.accessToken === 'cookie') return null;

    return { accessToken: session.accessToken, refreshToken: session.refreshToken };
  } catch {
    return null;
  }
}

export function writeAuthSession(session: AuthSession | null) {
  if (session) window.localStorage.setItem(storageKey, JSON.stringify(session));
  else window.localStorage.removeItem(storageKey);
}
